"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var rc_slider_1 = __importDefault(require("rc-slider"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
require("rc-slider/assets/index.css");
require("./styles.scss");
var RangeStepSlider = function (_a) {
    var title = _a.title, value = _a.value, onChangeHandler = _a.onChangeHandler, initialValue = _a.initialValue, marks = _a.marks;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.titleContainer },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, title),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, value)),
        react_1.default.createElement(rc_slider_1.default, { min: 0, max: Object.keys(marks).length - 1, marks: marks, defaultValue: initialValue, onChange: onChangeHandler })));
};
exports.default = RangeStepSlider;
